import Nullstack from 'nullstack';
export default function IconMoodOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mood-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5.634 5.638a9 9 0 0 0 12.732 12.724m1.679 -2.322a9 9 0 0 0 -12.08 -12.086"
  }), "   ", Nullstack.element("path", {
    d: "M9 10h.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 10h.01"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}